import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /**
   * justify-content 는 flex-start(상단 정렬) — center 금지.
   *
   * center 로 두면 "콘텐츠 높이 ≤ 뷰포트" 인 동안 컨텐츠를 세로 중앙에 모으는데,
   * 첫 진입 시 하단 섹션·이미지(컨베이어 등)가 비동기로 늦게 로드되면 그 짧은 순간
   * 콘텐츠가 뷰포트보다 짧아져 CTA 버튼이 중앙으로 끌려 올라갔다가, 로드 완료 후
   * 콘텐츠가 길어지면 제자리로 내려오는 레이아웃 시프트가 발생한다.
   * CouponStep 은 항상 뷰포트보다 길고(min-height:100% 로 짧아도 화면을 채움),
   * 로딩 스피너는 LoadingWrapper 가 자체 중앙 정렬하므로 center 는 불필요하다.
   */
  justify-content: flex-start;
  min-height: 100%;
  gap: 16px;
`
